import { VantifyProxyResponse, vantifyRequest } from 'integrations-vantify-api-client';
import { VantifyAuth, VantifyQuery } from '../common';
import { SubJobGroupListResponse } from './types';

/**
 * Get sub job groups (subcategories) for a given parent jobGroupId
 */
export async function getSubJobGroups(
  auth: VantifyAuth,
  jobGroupId: number,
  query?: VantifyQuery
): Promise<VantifyProxyResponse<SubJobGroupListResponse>> {
  const DEFAULT_LIMIT = 500;

  return await vantifyRequest<SubJobGroupListResponse>({
    method: 'GET',
    pathname: 'jobgroups',
    query: {
      fetchHierarchy: false,
      active: 1,
      parent: jobGroupId,
      limit: DEFAULT_LIMIT,
      ...query,
    },
    auth,
  });
}
